const timeValuesAM: string[] = [
  "1200AM",
  "1215AM",
  "1230AM",
  "1245AM",
  "0100AM",
  "0115AM",
  "0130AM",
  "0145AM",
  "0200AM",
  "0215AM",
  "0230AM",
  "0245AM",
  "0300AM",
  "0315AM",
  "0330AM",
  "0345AM",
  "0400AM",
  "0415AM",
  "0430AM",
  "0445AM",
  "0500AM",
  "0515AM",
  "0530AM",
  "0545AM",
  "0600AM",
  "0615AM",
  "0630AM",
  "0645AM",
  "0700AM",
  "0715AM",
  "0730AM",
  "0745AM",
  "0800AM",
  "0815AM",
  "0830AM",
  "0845AM",
  "0900AM",
  "0915AM",
  "0930AM",
  "0945AM",
  "1000AM",
  "1015AM",
  "1030AM",
  "1045AM",
  "1100AM",
  "1115AM",
  "1130AM",
  "1145AM",
];

const timeValuesPM: string[] = [
  "1200PM",
  "1215PM",
  "1230PM",
  "1245PM",
  "0100PM",
  "0115PM",
  "0130PM",
  "0145PM",
  "0200PM",
  "0215PM",
  "0230PM",
  "0245PM",
  "0300PM",
  "0315PM",
  "0330PM",
  "0345PM",
  "0400PM",
  "0415PM",
  "0430PM",
  "0445PM",
  "0500PM",
  "0515PM",
  "0530PM",
  "0545PM",
  "0600PM",
  "0615PM",
  "0630PM",
  "0645PM",
  "0700PM",
  "0715PM",
  "0730PM",
  "0745PM",
  "0800PM",
  "0815PM",
  "0830PM",
  "0845PM",
  "0900PM",
  "0915PM",
  "0930PM",
  "0945PM",
  "1000PM",
  "1015PM",
  "1030PM",
  "1045PM",
  "1100PM",
  "1115PM",
  "1130PM",
  "1145PM",
];

export const timeValues = [...timeValuesAM, ...timeValuesPM];
